'use client';
/* eslint-disable tailwindcss/no-custom-classname */

import { ComponentPreComparisonChecklist } from './types';

const formatBadge = (index: number) => String(index + 1).padStart(2, '0');

export const PreComparisonChecklist = ({
  moduleTitle,
  items,
}: ComponentPreComparisonChecklist): JSX.Element | null => {
  const visibleItems = items.filter(
    (item) => item.title?.trim() || item.description?.trim(),
  );

  if (!moduleTitle?.trim() || !visibleItems.length) {
    return null;
  }

  return (
    <section className="w-full rounded-radius/card border border-borders/default p-spacing/padding/x bg-fill/card">
      <div className="flex flex-col gap-spacing/padding/y-sm">
        <h2 className="mhg-alpha-typography-display-1 text-text/primary">
          {moduleTitle}
        </h2>

        <div className="flex flex-col">
          {visibleItems.map((item, index) => (
            <div
              key={item.id || `${item.title}-${index}`}
              className={`flex items-start gap-spacing/padding/x-sm py-spacing/padding/y-sm ${
                index < visibleItems.length - 1
                  ? 'border-b border-borders/default'
                  : ''
              }`}
            >
              <div className="flex min-h-8 min-w-8 shrink-0 items-center justify-center rounded-radius/table px-spacing/gap/x-xs py-spacing/gap/y-xs bg-fill/primary-light">
                <span className="mhg-alpha-typography-bullet-1 text-fill/primary-dark">
                  {formatBadge(index)}
                </span>
              </div>

              <div className="flex min-w-0 flex-1 flex-col gap-spacing/gap/soft-8px">
                {item.title && (
                  <h3 className="mhg-alpha-typography-bullet-1 text-fill/primary-dark">
                    {item.title}
                  </h3>
                )}
                {item.description && (
                  <p className="mhg-alpha-typography-body-2-relaxed text-text/secondary-lighter">
                    {item.description}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
